import { gql } from 'apollo-angular';

export var committee_calendar_date_hover = gql`
  query committeeCalendarDateHover($project: ID!, $roles: Mixed) {
    project(id: $project) {
      id
      is_repeat
      name
      projectSubstatusDates {
        substatus {
          name
          subsequence {
            name
          }
        }
        date
        utc_time
        timezone
      }
      participants(hasRole: { column: NAME, operator: IN, value: $roles }) {
        organization {
          name
        }
        person {
          name
        }
        role {
          name
        }
        sponsor {
          nickname
          is_repeat
          name
        }
      }
      projectMilestoneDates {
        dateType {
          name
        }
        date
      }
      projectCredits {
        projectCreditOutlets {
          fund {
            id
            name
          }
          certificatedOutlet {
            organization {
              id
              name
            }
          }
        }
      }
    }
  }
`;
